<script>
import HeaderTopbar from 'components/common/HeaderTopbar'
import TextButton from 'components/common/TextButton'
import ToolsCarousel from 'components/edu/ToolsCarousel'
import CoreModules from 'components/edu/CoreModules'
import FeaturesCarousel from 'components/edu/FeaturesCarousel'

export default {
  name: 'EduSolution',
  components: { HeaderTopbar, TextButton, ToolsCarousel, CoreModules, FeaturesCarousel },

  methods: {
    toTrialPage () {
      this.$router.push({name: 'trial'})
    }
  }
}
</script>

<template lang="pug">
section.solution-edu.dm-corp-page
  header-topbar(theme="invert" active-item="solutions"
                scroll-bg="#1C67FE" scroll-theshold="100" watch-scroll)

  section.above-the-fold
    .hero-image-container.main-container
      h1.hero-title 学校心理评估与发展指导智能平台
      .cta-buttons
        text-button(theme="white" size="large" rounded @click="toTrialPage") 申请试用
        //- text-button(theme="white-outline" size="large" rounded) 进入平台
      .hero-image

    .introduction.main-container      
      h3.intro-title 智能平台介绍
      p.intro-text 借助先进的云计算、大数据、人工智能等技术，为中小学、中高职学校提供科学心理评估和学生发展指导服务。
      .intro-blocks-wrapper
        .intro-block
          .block-image
            .dmico-edu-intro-1
          h4.block-title 五大发展主题
          p 覆盖品德个性、心理健康、学情诊断、生活与家庭、生涯规划等五大主题，科学评价学生心理发展质量并给予指导建议。
        .intro-block
          .block-image
            .dmico-edu-intro-2
          h4.block-title 六大功能模块
          p 从心理测评、指导、建档、分析，到心理咨询管理、危机预警和干预，助力学校建立闭环管理体系。
        .intro-block
          .block-image
            .dmico-edu-intro-3
          h4.block-title 七大平台亮点
          p 独家拥有「 EDUCATE 」七大亮点，全面提升素质教育的智慧化水平，促进学生实现全面而有个性的成长。
        .intro-block
          .block-image
            .dmico-edu-intro-4
          h4.block-title 紧贴新教改
          p 遵循教育部、国务院近年来所发布的多份教育改革纲要文件精神，结合学校管理具体需要，量身定做而成。

  section.dev-tools-section.edu-section
    .main-container
      .development-tools
        h3.section-title 全面覆盖五大发展主题的评估与指导工具
        tools-carousel.tools-carousel

  section.edu-section.primary-bg
    .main-container
      h3.section-title 六大核心功能模块 —— 数据打通 + 管理闭环

      .core-modules
        .core-module-graph-container
          core-modules(in-viewport-once)

        .module-features
          .feature-block
            h4.feature-title 测评计划
            .feature-text
              p 学校可根据应用场景需求，自行任意组合各种评估与指导工具，形成测评计划并一键精准分发到目标学生群体。
              p 计划完成后将自动生成个体报告，为学生提供即时反馈和建议。
          .feature-block
            h4.feature-title 咨询管理
            .feature-text
              p 便捷的咨询预约功能，自定义设置咨询老师和预约日历。
              p 咨询记录数字化存档，独有多种角色权限设置功能，充分保障数据安全性、咨询记录保密性。
          .feature-block
            h4.feature-title 心理档案与团体分析
            .feature-text
              p 全面记录、动态跟踪、自动分析、精美呈现的学生心理档案。
              p 独有的团体分析功能，更可为学校提供分层分类（全校/年级/班级/类群）的学生发展分析报告。
          .feature-block
            h4.feature-title 危机预警与评估干预
            .feature-text
              p 平台可持续监测数据、自动识别潜在风险学生，推荐接受相应的辅导和干预。更可根据不同角色权限（如心理老师、班主任、家长）推送预警信息，以便进行深入评估，制定和实施干预方案。

  section.edu-section.features-section
    .main-container
      h3.section-title.mixed-title 独家拥有
        .text-educate.dmico-edu-title-educate(alt="EDUCATE")
        | 七大亮点
      features-carousel.features-carousel
  
  section.clients.edu-section
    .main-container
      h3.section-title 累计服务师生
      .highlight-number 500,000+
      text-button(theme="yellow" rounded @click="toTrialPage") 马上申请试用

  //- section.edu-section
  //-   .main-container
  //-     h3.section-title 海内外知名合作机构
  //-     .client-logos-container Facilities goes here
</template>

<style lang="scss">
@import "../styles/variables";

.solution-edu.dm-corp-page {
  margin-top: 0;

  .above-the-fold {
    padding-top: 60px;
    padding-bottom: 80px;
    background: linear-gradient(270deg, $bg-blue-gradient-light 0%, $primary-color 100%);

    .hero-image-container {
      position: relative;
      height: 540px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
    }
    
    .hero-title {
      font-size: 38px;
      margin-bottom: 0.8em;
      color: #fff;
    }

    .hero-image {
      @include bgImage;
      background-image: url(../assets/images/edu-hero-image.png);
      width: 600px;
      height: 470px;
      position: absolute;
      right: 30px;
      bottom: -10px;
    }

    .cta-buttons {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;

      .text-button {
        margin-right: 1em;
      }
    }
  }

  .introduction {
    background: rgba(31,96,229, 0.57);
    border-radius: 20px;
    color: #fff;
    margin-top: 30px;
    padding: 50px 40px;

    .intro-title {
      font-size: 32px;
    }

    .intro-title,
    .intro-text {
      text-align: center;
    }

    .intro-text {
      font-size: 14px;
      margin-top: 20px;
    }

    .intro-blocks-wrapper {
      margin: 50px -25px 0 -25px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: stretch;

      .intro-block {
        flex: 1 1 0.00001px;
        padding: 0 20px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;

        .block-image {
          margin-bottom: 30px;
          height: 117px;
          width: 220px;
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          align-items: flex-end;

          .dmico-home-intro-2 {
            position: relative;
            top: 7px;
          }
        }

        .block-title {
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          color: white(0.8);
        }
      }
    }
  }

  .edu-section {
    padding: 80px 0;

    .section-title {
      color: $text-dark;
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 50px;
    }

    &.primary-bg {
      background: linear-gradient(270deg, $bg-blue-gradient-light 0%, $primary-color 100%);
      color: #fff;

      .section-title {
        color: #fff;
      }
    }

    &.gray-bg {
      background: #F0F1F6;
    }
  }

  .dev-tools-section {
    padding-bottom: 0;
  }

  .development-tools {
    .tools-carousel {
      margin-top: 30px;
    }
  }

  .core-modules {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;

    .module-features {
      flex: 1 1 0.00001px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: flex-start;
      margin: 0 -1.8em;

      .feature-block {
        width: 50%;
        padding: 1.5em 1.8em;

        .feature-title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 0.8em;
        }

        .feature-text {
          font-size: 14px;
          opacity: 0.8;

          p {
            margin-top: .3em;
            &:first-of-type {
              margin-top: 0;
            }
          }
        }
      }
    }

    .core-module-graph-container {
      position: relative;
      margin-right: 100px;
    }
  }

  .features-section {
    .mixed-title {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: center;
      .text-educate {
        margin: 0 0.5em;
      }
    }
    .features-carousel {
      margin-top: 50px;
    }
  }

  .clients {
    padding: 0;

    background-image: url(../assets/images/edu-footer-bg.png),
                      linear-gradient(270deg, $bg-blue-gradient-light 0%, $primary-color 100%);
    background-repeat: no-repeat;
    background-position: 28% 50%,
                         0% 0%;
    background-size: contain,
                     cover;
    background-blend-mode: multiply;

    .main-container {
      position: relative;
      height: 380px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-end;
      padding-right: 150px;

      * {
        position: relative;
        z-index: 5;
      }
    }
    
    .section-title {
      line-height: 100%;
      margin-bottom: 0;
      color: #fff;
    }
    .highlight-number {
      color: #fff;
      font-size: 80px;
      line-height: 100%;
      margin: 30px 0;
    }
  }
}
</style>